import { gql } from '@apollo/client';

export const GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS = gql`
    query GetAccountDeliveryDriversByIds($accountIds: [Long!]!) {
        getAccountDeliveryDriversByIds(accountIds: $accountIds) {
            accountId
            verificationStatus
            status
            isEmployed
        }
    }
`;

export interface GetAccountDeliveryDriversByIdsResponse {
    getAccountDeliveryDriversByIds: Array<{
        accountId: number;
        verificationStatus: number;
        status: number;
        isEmployed: boolean;
    }>;
}

export interface GetAccountDeliveryDriversByIdsVariables {
    accountIds: number[];
}
